var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal-close-btn-point" }, [
      _c(
        "div",
        {
          staticClass: "modal-close-btn-container",
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_c("SVGModalClose")],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ap-modal-title-big" }, [
      _vm._v("\n        Выберите пользователя\n    ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ap-modal-element" }, [
      _c("div", { staticClass: "ap-modal-text" }, [
        _vm._v("\n            " + _vm._s(_vm.description) + "\n        ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showFilter,
              expression: "showFilter"
            }
          ],
          staticClass: "filter-selects"
        },
        [
          _c("div", { staticClass: "ap-filter-section-name" }, [
            _vm._v(
              "\n                Выберите переметры пользователя:\n            "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sidebar-borderline" }),
          _vm._v(" "),
          _c("SelectRegionCity", {
            attrs: {
              selectedRegionID: _vm.selectedParamValueRegion,
              selectedCityID: _vm.selectedParamValueCity
            },
            on: {
              regionSelected: _vm.selectRegion,
              citySelected: _vm.selectCity
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "ap-modal-input-name" }, [
            _vm._v("\n                Организация\n            ")
          ]),
          _vm._v(" "),
          _c("JHCustomSelect", {
            attrs: {
              selectOptions: _vm.optionsOrganizations,
              selectName: function(organization, key) {
                return organization.name
              },
              selectableParamCondition: function(organization, key) {
                return organization.id
              },
              selectedParamValue: _vm.selectedParamValueOrganization,
              visibleMessageLoading: _vm.waitingResponseToOrganizationRequest
            },
            on: { selected: _vm.selectOrganization },
            model: {
              value: _vm.inputOrganizationName,
              callback: function($$v) {
                _vm.inputOrganizationName = $$v
              },
              expression: "inputOrganizationName"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "sidebar-borderline" })
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "select-filter-grid" },
        [
          _c("JHCustomSelect", {
            attrs: {
              selectOptions: _vm.optionsUsers,
              selectName: function(user, key) {
                return user.fullname
              },
              selectableParamCondition: function(user, key) {
                return user.id
              },
              selectedParamValue: _vm.selectedParamValueUser,
              visibleMessageLoading: _vm.waitingResponseToUserRequest
            },
            on: {
              selected: _vm.selectUser,
              scrollReachEnd: _vm.scrollReachEndUsers,
              focusOnInput: _vm.updateUsers
            },
            model: {
              value: _vm.inputUserName,
              callback: function($$v) {
                _vm.inputUserName = $$v
              },
              expression: "inputUserName"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "filter-btn",
              on: {
                click: function($event) {
                  _vm.showFilter = !_vm.showFilter
                }
              }
            },
            [_c("SVGFilter", { staticClass: "filter-svg" })],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showAlert === "responsibleUser",
              expression: "showAlert === 'responsibleUser'"
            }
          ],
          staticClass: "form-alert-danger"
        },
        [_vm._v("\n            Обязательное поле!\n        ")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-button", on: { click: _vm.apply } }, [
      _vm._v("\n        Подтвердить\n    ")
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ap-modal-input-name" }, [
      _vm._v("\n            Ответственный "),
      _c("span", { staticClass: "red-text" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }